<template>
  <div class="mt-6">
    <div class="d-flex align-center justify-space-between px-6 pb-4">
      <span
        data-testid="teamActivity-text-activityTitle"
        class="text-subtitle-2 font-weight-bold"
      >
        {{ $t('team.activity.teams_activity_title') }}
      </span>
    </div>

    <div class="mx-6">
      <v-row no-gutters>
        <v-col cols="8">
          <v-tabs slider-size="4" slider-color="blue">
            <v-tab
              active-class="blue-grey--text text--darken-3"
              class="blue-grey--text text--darken-1"
              @click="selectRevsTab"
            >
              {{ $t('common.rev_other') }}
            </v-tab>
            <template v-if="hasRoutinesFeatureEnabled">
              <v-tab
                active-class="blue-grey--text text--darken-3"
                class="blue-grey--text text--darken-1"
                @click="selectFindingsTab"
              >
                {{ $t('assignments.finding_other') }}
              </v-tab>

              <v-tab
                active-class="blue-grey--text text--darken-3"
                class="blue-grey--text text--darken-1"
                @click="selectRoutinesTab"
              >
                {{ $t('routines.routine_other') }}
              </v-tab>
            </template>
          </v-tabs>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <v-row class="mt-n16">
        <v-col cols="12">
          <RevsTab v-show="activeTab === TABS_OPTIONS.revs" :teamId="team.id" />
          <template v-if="hasRoutinesFeatureEnabled">
            <FindingsTab
              data-testid="teamActivity-tab-findings"
              v-show="activeTab === TABS_OPTIONS.findings"
              :teamId="team.id"
            />

            <RoutinesTab
              data-testid="teamActivity-tab-routines"
              v-show="activeTab === TABS_OPTIONS.routines"
              :teamId="team.id"
            />
          </template>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import mixin from '@/mixins/mixin.vue'
import RevsTab from '@/components/TeamActivityTables/RevsTab.vue'
import FindingsTab from '@/components/TeamActivityTables/FindingsTab.vue'
import RoutinesTab from '@/components/TeamActivityTables/RoutinesTab.vue'

const TABS_OPTIONS = {
  routines: 'routines',
  revs: 'revs',
  findings: 'findings',
}

export default {
  name: 'Activity',

  mixins: [mixin],

  components: {
    RevsTab,
    FindingsTab,
    RoutinesTab,
  },

  props: {
    team: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      activeTab: TABS_OPTIONS.revs,
      TABS_OPTIONS,
    }
  },

  computed: {
    ...mapGetters(['organizationId', 'organization']),

    hasRoutinesFeatureEnabled() {
      return Boolean(this.organization?.featuresEnabled__routines)
    },
  },

  methods: {
    selectRoutinesTab() {
      this.activeTab = TABS_OPTIONS.routines
    },

    selectFindingsTab() {
      this.activeTab = TABS_OPTIONS.findings
    },

    selectRevsTab() {
      this.activeTab = TABS_OPTIONS.revs
    },
  },
}
</script>
